// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__vyIOU {

  margin-top: 6px;
  margin-bottom: 0;

  overflow: hidden;

  font-size: 13px;
  color: var(--colorFail);

  @media (min-width: 768px) {
    margin-top: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/sharetribe/components/ValidationError/ValidationError.module.css"],"names":[],"mappings":"AAEA;;EAGE,eAAe;EACf,gBAAgB;;EAEhB,gBAAgB;;EAEhB,eAAe;EACf,uBAAuB;;EAEvB;IACE,eAAe;EACjB;AACF","sourcesContent":["@import '../../../styles/customMediaQueries.css';\n\n.root {\n  composes: h4 from global;\n\n  margin-top: 6px;\n  margin-bottom: 0;\n\n  overflow: hidden;\n\n  font-size: 13px;\n  color: var(--colorFail);\n\n  @media (--viewportMedium) {\n    margin-top: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__vyIOU h4`
};
export default ___CSS_LOADER_EXPORT___;
